export const MAX_IP_ADDRESS_ENTRIES = 64;

export const defaultIpAddressItem = {
  ipAddress: "",
  subnet: "32",
  description: "",
};

export const defaultIpAddressObj = {
  name: "",
  ipAddresses: [],
};
